import { useSortable } from "@dnd-kit/sortable";
import {CSS} from '@dnd-kit/utilities';
import { SelectCategory } from "./SelectCategory";
import { ColorOption } from "../../../../components/Form/ColoredSelectFields";
import { TreeSelectedCategory } from "../../../../hooks/useModelFamilyTree";

export default function SortableSelectCategory({
    index,
    selectedCategory,
    allCategories,
    handleSelectCategory,
    handleAddCategory,
    handleRemoveCategory,
    count,
}: {
    index: number,
    selectedCategory: TreeSelectedCategory,
    allCategories: ColorOption[],
    handleSelectCategory: (e: any, name: string) => void,
    handleAddCategory: () => void,
    handleRemoveCategory: (id: string) => void,
    count: number,
}) {

    const { id } = selectedCategory;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({id});

    
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        // zIndex: isDragging ? "100" : "auto",
        opacity: isDragging ? 0.3 : 1,
    };

    return (
        <SelectCategory 
            id={id}
            selectedCategory={selectedCategory}
            allCategories={allCategories}
            handleSelectCategory={handleSelectCategory}
            handleAddCategory={handleAddCategory}
            handleRemoveCategory={handleRemoveCategory}
            index={index}
            count={count}
            ref={setNodeRef}
            style={style}
            dragProps={{...attributes, ...listeners}}
        />
    )
}